define('BRListrak', [
    'Utils',
    'SC.Configuration',

    'BRListrak.Lib',
    'Cart.AddToCart.Button.View',
    'Cart.Detailed.View',
    'ProductDetails.Full.View',
    'ProductDetails.QuickView.View',

    'BRListrakReCart.View',
], function (
    Utils,
    Configuration,
    BRListrakLib,
    AddToCartButtonView,
    CartDetailedView,
    ProductDetailsFullView,
    ProductDetailsQuickView,
    BRListrakReCartView,
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var isEnabled = Configuration.get('BRListrak.isEnabled') || false;
            var merchantID = Configuration.get('BRListrak.MerchantId');
            if (!isEnabled || !merchantID || !BRListrakLib.isBrowserEnvironment('shopping.mountToApp'))
                return;

            // Load Framework
            // container.getLayout().once('afterAppendView', jQuery.proxy(this, 'loadScript'));
            container.getLayout().once('afterAppendView', function (view) {
                BRListrakLib.loadScript(merchantID);
            });

            var layout = container.getComponent('Layout');
            if (layout) {
                layout.on('afterShowContent', function afterShowContent(viewName) {
                    //console.log(`viewName: ${JSON.stringify(viewName)}`);

                    // Browse Abandonment: Browsing a Page
                    BRListrakLib.browseAbandonmentPage();

                    switch (viewName) {
                        // Email Capture
                        case 'LoginRegister.View':
                            BRListrakLib.loadEmailCapture("login-email");
                            break;
                        case 'checkout':
                            if (document.querySelector("#email"))
                                BRListrakLib.loadEmailCapture("email");
                            break;
                        default:
                            break;
                    }
                });
            }

            // Browse Abandonment: Browsing a Product
            ProductDetailsFullView.prototype.getContext = _.wrap(ProductDetailsFullView.prototype.getContext, function (fn) {
                var context = fn.apply(this, _.toArray(arguments).slice(1));
                BRListrakLib.browseAbandonmentProd(this.model.getItem().getSku());
                return context;
            });
            ProductDetailsQuickView.prototype.getContext = _.wrap(ProductDetailsQuickView.prototype.getContext, function (fn) {
                var context = fn.apply(this, _.toArray(arguments).slice(1));
                BRListrakLib.browseAbandonmentProd(this.model.getItem().getSku());
                return context;
            });

            // Cart Abandonment
            _.extend(AddToCartButtonView.prototype, {
                addToCart: function addToCart(e) {
                    BRListrakLib.addToCart(e, this);
                }
            });
            _.extend(CartDetailedView.prototype, {
                removeItem: function removeItem(e) {
                    this.isCartChanged = true;
                    BRListrakLib.removeItem(e, this);
                },
                updateItemQuantity: function updateItemQuantity(e) {
                    this.isCartChanged = true;
                    BRListrakLib.updateItemQuantity(e, this);
                },
                initialize: _.wrap(CartDetailedView.prototype.initialize, function (fn, options) {
                    fn.apply(this, _.toArray(arguments).slice(1));

                    var self = this;
                    this.isCartChanged = false;
                    this.on('afterViewRender', function (event, view) {
                        setTimeout(function () {
                            //console.log('Cart Rendered');
                            if (!self.isCartChanged) {
                                self.sendCartToListrak();
                            }
                            self.isCartChanged = false;
                        }, 1000);
                    });
                }),
                sendCartToListrak: function () {
                    BRListrakLib.sendCartToListrak();
                }
            });

            // Re-Cart
            var PageType = container.getComponent('PageType');
            var cart = container.getComponent('Cart');

            PageType.registerPageType({
                name: 'BRListrakRecart',
                routes: ['recart'],
                view: BRListrakReCartView,
                defaultTemplate: {
                    name: 'BRListrakRecart.tpl',
                    displayName: 'Bronner Listrak ReCart'
                }
            });

            BRListrakReCartView.prototype.getContext = _.wrap(BRListrakReCartView.prototype.getContext, function (fn) {
                var context = fn.apply(this, _.toArray(arguments).slice(1));

                var url = new URL(window.location.href);

                var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/BRListrak.Service.ss'));
                var callUrl = service_url + url.search + '&func=ItemsSearch';

                async function postData(url) {
                    try {
                        // Default options are marked with *
                        var response = await fetch(url, {
                            method: 'GET', // *GET, POST, PUT, DELETE, etc.
                            mode: 'cors', // no-cors, *cors, same-origin
                            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                            credentials: 'same-origin', // include, *same-origin, omit
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            redirect: 'follow', // manual, *follow, error
                            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                        });
                        var resj = await response.json();
                        //console.log('resj', resj);

                        await handleData(resj);
                        //console.log("END - Redirect to cart in now!");

                    } catch (error) {
                        console.error(error);
                    }
                }

                postData(callUrl);

                async function handleData(res) {try {
                        var currentLines = await cart.getLines();
                        if (currentLines && currentLines.length > 0) {
                            var removePromises = [];
                            for (var i = 0; i < currentLines.length; i++) {
                                removePromises.push(
                                    cart.removeLine({
                                        line_id: currentLines[i].internalid
                                    })
                                );
                            }
                            await Promise.all(removePromises);
                        }

                        var linesData = [];
                        if (res && res.data && res.data.length > 0) {
                            for (var index = 0; index < res.data.length; index++) {
                                var element = res.data[index];
                                linesData.push({
                                    quantity: parseInt(element.qty, 10),
                                    item: {
                                        internalid: parseInt(element.itemId, 10)
                                    }
                                });
                            }
                        }

                        if (linesData.length > 0) {
                            await cart.addLines({
                                lines: linesData
                            });
                            setTimeout(function () {
                                window.location.replace('./cart');
                            }, 500);
                        }

                        return { isSuccess: true };
                    } catch (error) {
                        console.error('handleData.ERROR', error);
                        throw error;
                    }
                }

                return context;
            });

        }
    };
});
